import { Header } from 'app/App.components/Header/Header.controller'
import { HomeView } from './Home.view'

export const Home = () => {
  return (
    <>
      <Header />
      <HomeView />
    </>
  )
}
